export default {
  FEATURED: 'featured',
  FEATURED_HOUSE_NOTES: 'featured-house-notes',
  SIMILAR: 'similar',
  PROMOTIONAL: 'promotional',
  ALL: 'all',
  MED: 'med',
  SMALL: 'small',
  TINY: 'tiny'
}
